import { changeTourAnchorProps } from '@gonfalon/change-tour/anchor';

export const SETTINGS_TOUR_KEY = 'flattenedSettings';
export const SETTINGS_TOUR_DISMISSAL_KEY = 'flattened-settings-tour-v1';

export const settingsTourSteps = {
  overview: 'overview',
  search: 'search',
  switchProjects: 'switch-projects',
  projectSettings: 'project-settings',
} as const;

export function settingsTourAnchor(step: (typeof settingsTourSteps)[keyof typeof settingsTourSteps]) {
  return changeTourAnchorProps(SETTINGS_TOUR_KEY, step);
}
